<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>
		<div class="layout m-dqgyList">
			<div class="list_count no-padding-top">
				<div class="wow fadeInUp animated" data-wow-delay="0.5s">
					<img v-if="index==0" class="list_img" :src="zidiyiData.public_welfare.files" />
					<img v-if="index==1" class="list_img" :src="zidiyiData.axgy.files" />
				</div>
				<div class="list_info">
					<div v-if="index==0" class="describition wow fadeInUp animated"
						v-html="lang=='CN' ? zidiyiDataDes.cn_content:zidiyiDataDes.en_content"></div>
					<div v-if="index==1" class="describition wow fadeInUp animated"
						v-html="lang=='CN' ? zidiyiDataDes2.cn_content:zidiyiDataDes2.en_content"></div>

					<!-- 列表 -->
					<div class="row wrap">

						<div class="liebiao_list col-xs-12 col-lg-10">
							<!--海报 GO-->
							<div class="swiper-container" v-if="haiBao.length>0 && index!=0">
								<swiper :options="swiperOption" ref="mySwiper" :pagination="{clickable:true}">
									<div class="swiper-slide" v-for="(item,index) in haiBao" :key="item"
										@click="go_open(outlink)">
										<div class="photo"> <img :src="item" style="width: 1138px;height: 608px;"
												alt="爱心公益"></div>
									</div>
								</swiper>
								<!-- 如果需要分页器 -->
								<div class="swiper-pagination">
								</div>
								<div class="swiper-scrollbar">
								</div>
							</div>




							<!-- 党群列表 GO -->
							<div class="pro-news" v-if="index==0">
								<div class="info_tit short">
									<div class="tit_left">
										<span>党群公益</span>
										<el-divider direction="vertical"></el-divider>
										<span>PARTY-MASSES & PUBLIC WELFARE</span>
									</div>
									<div class="tit_right f14" @click="go_list(33)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<!-- 列表 -->
								<div class="liebiao_list wow fadeInUp animated" data-wow-delay="0.5s"
									data-wow-offset='0'>
									<div class="liebiao_info spe css3 wow fadeInUp animated"
										v-for="(item,index) in dangqunList" data-wow-delay="0.5s" data-wow-offset='0'
										:key="item.id">
										<div class="info_left">
											<img class="css3" :src="item.image"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" />
										</div>
										<div class="info_right"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
											<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
											<div class="right_down">
												<span>{{item.publishtime_text}}</span>
												<div class="right_down_div">
													<span class="commo_span">
														<img class="eye" src="@/assets/news/eye.svg" />
														<span>{{item.view}}</span>
													</span>
													<span class="commo_span">
														<img src="@/assets/news/comment.svg" />
														<span>{{item.comment_num}}</span>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>




							<div class="pro-gaikuang" v-if="tab==1 && index==1">
								<div class="info_tit">
									<div class="tit_left">
										<span>基金会概况</span>
										<el-divider direction="vertical"></el-divider>
										<span>INTRODUCE</span>
									</div>
								</div>
								<div class="cont wow fadeInUp animated" data-wow-delay="0.5s" v-if="tab==1 && index==1"
									v-html="lang=='CN' ?zidiyiSingle.cn_content:zidiyiSingle.en_content">
								</div>
							</div>

							<div v-if="tab==3" class="wow fadeInUp animated" data-wow-delay="0.5s">
								<div class="liebiao_info css3" v-for="(item,index) in arcList" @click="go(item.id)">
									<div class="info_left col-xs-12 col-lg-3">
										<div class="border-hover css3"></div>
										<img class="css3" :src="item.image" />
									</div>
									<div class="info_right col-xs-12 col-lg-9">
										<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
										<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
										<div class="right_down">
											<span>{{item.publishtime_text}}</span>
											<div class="right_down_div">
												<span class="commo_span">
													<img class="eye" src="@/assets/news/eye.svg" />
													<span>{{item.view}}</span>
												</span>
												<span class="commo_span">
													<img src="@/assets/news/comment.svg" />
													<span>{{item.comment_num}}</span>
												</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 分页 -->
								<div class="fenye">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="currentPage4" background :page-size="per_page"
										layout="total, prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
							</div>


							<!-- 正佳慈善基金会——新闻资讯 GO -->
							<div class="pro-news last" v-if="tab==1 && index==1">
								<div class="info_tit">
									<div class="tit_left">
										<span>新闻资讯</span>
										<el-divider direction="vertical"></el-divider>
										<span>NEWS</span>
									</div>
									<div class="tit_right f14" @click="go_list(34)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<!-- 列表 -->
								<div class="liebiao_list wow fadeInUp animated" data-wow-delay="0.5s"
									data-wow-offset='0'>
									<div class="liebiao_info css3 wow fadeInUp animated"
										v-for="(item,index) in gyxmList" data-wow-delay="0.5s" data-wow-offset='0'
										:key="item.id">
										<div class="info_left">
											<img class="css3" :src="item.image" @click="go(item.id)" />
										</div>
										<div class="info_right" @click="go(item.id)">
											<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<span class="jieshao">{{lang=='CN' ?item.cn_cont:item.en_cont}}</span>
											<div class="right_down">
												<span>{{item.publishtime_text}}</span>
												<div class="right_down_div">
													<span class="commo_span">
														<img class="eye" src="@/assets/news/eye.svg" />
														<span>{{item.view}}</span>
													</span>
													<span class="commo_span">
														<img src="@/assets/news/comment.svg" />
														<span>{{item.comment_num}}</span>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- 正佳慈善基金会——合作伙伴 GO -->
							<div class="pro-partner" v-if="tab==1 && index==1">
								<div class="info_tit">
									<div class="tit_left">
										<span>合作伙伴</span>
										<el-divider direction="vertical"></el-divider>
										<span>COOPERATIVE PARTNER</span>
									</div>
									<div class="tit_right f14" @click="go_list(153)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<!-- 列表 -->
								<div class="partner_content">
									<div class="item pointer" v-for="(item,index) in hezuoList" v-if="index<8"
										@click="go(item.id)">
										<div class="icom_f">
											<img :src="item.image" />
										</div>
									</div>
								</div>

							</div>
							<!-- 班级信息 GO -->
							<div class="pro-squadInfo" v-if="tab==2 && index==1">
								<div class="info_tit">
									<div class="tit_left">
										<span>班级信息 </span>
										<el-divider direction="vertical"></el-divider>
										<span>CLASS INFORMATION</span>
									</div>
									<div class="tit_right f14" @click="go_class()">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="row">
									<div class="squadInfo_content col-xs-12 col-lg-12">
										<div class="item pointer" v-for="(item,index) in banjiList"
											@click="go_student(item.id)">
											<div class="pic">
												<img :src="item.image" />
											</div>
											<div class="bottom">
												<div class="title line-1">{{item.name}}</div>
											</div>
										</div>
										
										<div v-if="banjiList.length==0">
											暂无数据~
										</div>
										
									</div>
								</div>
							</div>
							<!-- 就业信息 GO -->
							<div class="pro-employment" v-if="tab==2 &&index==1">
								<div class="info_tit">
									<div class="tit_left">
										<span>就业信息 </span>
										<el-divider direction="vertical"></el-divider>
										<span>EMPLOYMENT INFORMATION</span>
									</div>
									<div class="tit_right f14" @click="go_list(151)">
										<span>查看更多</span>
										<el-divider direction="vertical"></el-divider>
										<span>MORE</span>
									</div>
								</div>
								<div class="row">
									<div class="jiuye col-xs-12 col-lg-12">
										<div class="item" v-for="(item,index) in jiuyeList" :key="index">
											<div class="occupation">
												{{item.seo1}}
											</div>
											<div class="firm">
												{{item.seo2}}
											</div>
											<div class="data">
												{{item.publishtime_text}}
											</div>
										</div>
										
										
										<div v-if="jiuyeList.length==0" style="padding-top: 20px;">
											暂无数据~
										</div>
										
									</div>
								</div>
							</div>
						</div>
						<!-- 列表 -->
						<div class="subject_count_right col-xs-12 col-lg-2">
							<div>
								<div class="commo_div" @click="choose_type(0)">
									<span>{{lang=='CN' ?list[0].cn_name:list[0].en_name}}</span>
									<img src="@/assets/img/liebiao_logo.png" />
								</div>
								<div class="commo_div" @click="choose_type(1)">
									<span>{{lang=='CN' ?list[1].cn_name:list[1].en_name}}</span>
									<img v-if="type==0" src="@/assets/img/liebiao_logo.png" />
									<span v-if="type==1">收起</span>
								</div>
								<div v-if="showSubTitle" class="commo_list zb_list">
									<span @click="getZidiyiSingle(1,'zhengjia')"
										:class="tab==1 ? 'active_style' : ''">{{lang=='CN' ?'正佳慈善基金会':'Zhengjia Charitable Foundation'}}</span>
									<span @click="getZidiyiSingle(2,'zhengjiaqiaoxinban');"
										:class="tab==2 ? 'active_style' : ''">{{lang=='CN' ?'正佳侨心班':'Good overseas Chinese heart class'}}</span>
									<!-- <span @click="getZidiyiSingle(3);"
										:class="tab==3 ? 'active_style' : ''">{{lang=='CN' ?'活动资讯':'Activity information'}}</span> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		channel_list,
		add_pv,
		get_file,
		get_file_all,
		get_content,
		archives_list,
		get_banner,
		banji_list,
		student_list,
		archives_list_new
	} from '@/api/api.js'
	import {
		WOW
	} from 'wowjs'
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"
	import 'swiper/css/swiper.css'
	export default {
		components: {
			Header,
			Footer,
			swiper,
			swiperSlide
		},
		name: 'dqgy',
		data() {
			return {
				index: 0,
				currentPage4: 1,
				parent_id: 12,
				tab: 1,
				list: [{
						cn_name: '',
						en_name: ''
					},
					{
						cn_name: '',
						en_name: ''
					},
				], //
				jx_index: '',
				per_page: 9,
				curr: 0,
				type: 0,
				showSubTitle: false,
				zidiyiData: {
					public_welfare: {
						files: ''
					},
					axgy: {
						files: ''
					},
				},
				zidiyiDataDes: '',
				zidiyiDataDes2: '',
				zidiyiSingle: '',
				page: 1,
				arcList: [], //内容列表
				dangqunList: [], //内容列表

				content: {}, //内容详情
				total: 0,
				company_id: 1, //公司ID
				banner: '',
				banjiList: [], //班级
				jiuyeList: [], //就业信息

				zjxwList: [], //正佳新闻
				haiBao: [], //正佳海报轮播
				outlink: '',
				swiperOption: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 1,
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},
				gyxmList: [], //公益项目
				hezuoList: [], //合作伙伴
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			localStorage.setItem('current', 4)
			this.getZidiyiData() //自定义图片
			this.getZidiyiDataDes();
			this.getBanner();
			this.addLocatPath()

			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {
			this.parent_id = this.$route.query.parent_id

			this.getDangqunList(33)
			this.getZidiyiSingle(1, "zhengjia")
			this.getZidiyiSingle(2, "zhengjiaqiaoxinban")
			this.getArchivesList(34)

			if (this.$route.query.index) {
				this.index = this.$route.query.index
				// this.tab = this.$route.query.curr
				this.getChannelList();
				this.getZidiyiData() //自定义图片
				this.getZidiyiDataDes();

				if (this.index == 1) {
					this.showSubTitle = true
				}
				return
			}
			localStorage.setItem('current', 4)
			let data = {
				parent_id: this.parent_id
			}

			channel_list(data).then((res) => {
				if (res.code == 1) {
					this.list = res.data
					if (res.data) {
						this.jx_index = res.data[0].id
						this.getArchivesList(res.data[0].id)
					}
				}
			}).catch(err => {});

		},
		methods: {
			// 打开外链
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			go_class() {
				this.$router.push({
					path: `classlist`,
					query: {
						parent_id: this.parent_id,
					}
					
				})
			},

			// 获取基金会轮播
			getHaiBao() {
				let data = {
					keys: 'zjjjhgk'
				}
				get_file(data).then((res) => {

					this.haiBao = res.data.zjjjhgk.files.split(",")
					this.outlink = res.data.zjjjhgk.outlink
				}).catch(err => {});
			},
			//更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			//正佳侨心班——就业信息 
			getAllNewsList() {
				let temp = [],
					data = {
						channel_id: '151', //151 就业信息 
						per_page: '8'
					}
				archives_list_new(data).then((res) => {
					temp = res.data
					this.jiuyeList = temp[0] ? temp[0].data : temp
				}).catch(err => {});
			},
			//正佳慈善基金会——
			getAllNewsList1() {
				let temp = [],
					data = {
						channel_id: '113,152,153', //113 正佳慈善基金会——新闻资讯 152 正佳慈善基金会——公益项目 153 正佳慈善基金会——合作伙伴
						per_page: '5,8,8'
					}
				archives_list_new(data).then((res) => {
					temp = res.data
					this.zjxwList = temp[0] ? temp[0].data : temp
					this.gyxmList = temp[1] ? temp[1].data : temp
					this.hezuoList = temp[2] ? temp[2].data : temp
				}).catch(err => {});
			},
			// 正佳侨心班——班级
			getBanJi() {
				let data = {
					page: 1,
					per_page: 9
				}
				banji_list(data).then((res) => {
					if (res.code == 1) {
						this.banjiList = res.data.data
					}
				}).catch(err => {});
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			toggleNext(index) {
				this.choose_type(index)
			},
			addLocatPath() {
				let data = {
					directions: '党群公益',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},
			getBanner() {
				let data = {
					company_id: this.company_id,
					tag: '党群公益'
				}
				get_banner(data).then((res) => {
					if (res.code == 1) {
						this.banner = res.data
						// console.log(this.banner);
					}
				}).catch(err => {});
			},
			getChannelList() {
				let data = {
					parent_id: this.parent_id
				}
				channel_list(data).then((res) => {
					if (res.code == 1) {
						this.list = res.data
					}
				}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},
			// 获取自定义富文本
			getZidiyiDataDes() {
				let data = {
					keys: 'dangqungongyi,aixingongyi'
				}
				get_content(data).then((res) => {
					this.zidiyiDataDes = res.data.dangqungongyi
					this.zidiyiDataDes2 = res.data.aixingongyi
				}).catch(err => {});
			},
			//自定义调用 正佳慈善基金会 正佳侨心班
			getZidiyiSingle(tab, keys) {
				let data = {
						keys: keys
					},
					that = this
				let new_http = window.location.origin
				if (new_http == this.prod) {
					new_http = this.prod + '/web/'
				}
				let url = new_http + `#/dqgy?parent_id=12&index=${this.index}&curr=${tab}`
				window.history.replaceState(null, '', url);
				get_content(data).then((res) => {

					this.zidiyiSingle = res.data[keys]
					that.tab = tab
					if (that.tab == 1) {
						this.getAllNewsList1()
						this.getHaiBao()
					}
					if (that.tab == 2) {
						this.getBanJi()
						this.getAllNewsList()
					}

				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},

			getDangqunList(id) {

				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then((res) => {

					res.data.data.map(item => {
						item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
							.en_content)
						item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
							.cn_content)
						this.dangqunList = res.data.data
						this.total = res.data.total
					})
				})
			},
			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then((res) => {

					res.data.data.map(item => {
						item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
							.en_content)
						item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
							.cn_content)
					})
					
					let temp = res.data.data
					

					if (res.code == 1) {
						if (id == 113) {
							this.arcList = temp
						}
						if (id == 152) {
							this.gyxmList = temp
						}
						this.total = res.data.total
					}
				}).catch(err => {});
			},
			detail(id) {
				let data = {
					id: id
				}
				archives_detail(data).then((res) => {
					if (res.code == 1) {
						this.content = res.data
					}
				}).catch(err => {});
			},
			choose_type(type) {
				this.index = type
				let temp = type
				let new_http = window.location.origin
				if (new_http == 'http://www.jiaxinhaitan.com/') {
					new_http = 'http://www.jiaxinhaitan.com/web/'
				}
				let url = new_http + `#/dqgy?parent_id=12&index=${type}`
				window.history.replaceState(null, '', url);
				this.jx_index = this.list[this.index].id
				this.getArchivesList(this.list[this.index].id)
				type === 0 ? this.showSubTitle = false : this.showSubTitle = true
				this.type == temp
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.detail(this.jx_index)
				this.getArchivesList(this.jx_index)
				console.log(`当前页: ${val}`);
			},
			//跳转页面
			goPage() {
				this.$router.push({
					path: `fzmemorabilia`
				})
			},
			go(id) {
				this.$router.push({
					path: `new_detail`,
					query: {
						id: id
					}
				})
			},
			go_student(id) {
				this.$router.push({
					path: `student`,
					query: {
						id: id
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.m-dqgyList .col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.m-dqgyList {
		background: #fff;

		.list_count {
			padding: 30px;

			.list_info {
				margin: 50px auto;
				max-width: 1400px;

				.describition {
					margin-bottom: 50px;
					border-bottom: 1px solid #DCDFE6;
					padding-bottom: 20px;
					font-size: 16px;
				}

				.info_tit {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;

					/deep/ .swiper-pagination-bullet {
						display: none;
					}

					.active {
						border: 2px solid #006170;
						box-shadow: 5px 7px 10px #cddadc;
						color: #000;
					}

					.tit_left {
						span:first-child {
							font-size: 30px;
							color: #000;
							font-weight: bold;
						}

						span:last-child {
							font-size: 12px;
							color: #999;
						}
					}
				}
			}

			.list_img {
				width: 100%;
			}

		}

		ul {
			width: 448px;
			position: absolute;
			top: 60px;
			right: 0;

			li:hover,
			li.current {
				border: 1px solid #006170;
				color: #006170;
			}


			li {
				height: 40px;
				line-height: 40px;
				text-align: center;
				color: #999;
				font-size: 14px;
				display: block;
				padding: 0 10px;
				border: 1px solid #eee;
				margin: 0 10px;
				float: left;
				cursor: pointer;
			}
		}

		.cont {
			min-height: 350px;
		}

		.jieshao:hover {
			opacity: 0.8;
		}

		.hover_span {
			cursor: pointer;
		}

		.row.wrap {
			width: 1400px;
			margin: 0 auto;
		}

		/* 轮播 */

		.swiper-container {
			left: 15px;
		}

		.swiper-button-prev::after {
			color: #d6d7dc;
		}

		.swiper-button-next::after {
			color: #d6d7dc;
		}

		/deep/ .swiper-pagination {
			bottom: 60px;
			position: relative;
		}

		/deep/ .swiper-pagination-bullet {
			width: 80px;
			height: 8px;
			background: #ffffff;
			margin-left: 10px;
			border-radius: 0;
		}

		/deep/ .swiper-pagination-bullet-active {
			background: #006170;
		}

		.liebiao_list {
			margin-top: 20px;
			position: relative;
			left: -30px;

			.cont {
				/deep/p {
					/deep/img {
						float: initial !important;
					}
				}
			}

			.liebiao_info {
				visibility: initial;
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				padding: 30px;
				cursor: pointer;
				position: relative;

				&::after {
					content: '';
					width: calc(100% - 30px);
					background: #dddee4;
					display: block;
					height: 1px;
					position: absolute;
					bottom: 0px;

				}

				&:hover {
					background: #f0f4f5;
				}

			}

			/* 正佳慈善基金会——概况 GO */
			.pro-gaikuang {
				padding: 73px 0 0 30px;
				overflow: hidden;

				.info_tit {
					margin-bottom: 28px;
				}

			}

			/* 正佳慈善基金会——公益项目 GO */
			.pro-charity {
				margin-left: 30px;
				margin-top: 64px;
				margin-right: -30px;
				display: inline-block;

				.charity_content {
					display: flex;
					flex-wrap: wrap;
					margin-top: 32px;

					.item {
						margin-right: 42px;
						margin-bottom: 42px;

						.pic {
							img {
								width: 260px;
								height: 180px;
							}
						}

						.bottom {
							width: 260px;
							margin: 6px 0 0px 0;
							display: flex;
							align-items: center;
							justify-content: space-between;
							color: #1a1a1a;

							.title {
								width: 260px;
								height: 32px;
								line-height: 32px;
								font-size: 18px;
								padding: 0 10px;
							}
						}

						.bottom:hover {
							color: #006170;
							cursor: pointer;
						}
					}

					.item:hover {
						margin: -21px 21px 21px -21px;
						padding: 21px;
						background: #f0f4f5;
					}

					.item:nth-child(4n) {
						margin-right: 0px;
					}

					.item:nth-child(4n):hover {
						margin: -21px -21px 21px -21px;
						padding: 21px;
					}
				}
			}



			/* 正佳慈善基金会——新闻资讯 GO */
			.pro-news {
				position: relative;
				left: 30px;

				.liebiao_list {
					margin: 20px 0 0 0;

					.liebiao_info {
						width: calc(100% + 60px);
						display: flex;
						flex-direction: row;
						justify-content: flex-start;
						padding: 30px 30px 30px 30px;
						cursor: pointer;
						position: relative;
						left: 0px;

						&:hover {
							background: #f0f4f5;
						}

						&::after {
							width: calc(100% - 60px);
							height: 1px;
							content: '';
							background: #f0f4f5;
							display: block;
							position: absolute;
							bottom: 0px;
						}

						.info_left {
							width: 320px;
							height: 180px;
							margin-right: 0px;

							img {
								width: 320px;
								height: 180px;

							}
						}

						.info_right {
							width: 805px;
							height: 180px;
							margin-left: 40px;
							margin-right: -30px;
						}
					}
				}
			}

			/* 正佳慈善基金会——合作伙伴 GO */
			.pro-partner {
				margin-top: 64px;
				position: relative;
				left: 30px;

				.partner_content {
					margin-top: 32px;
					display: flex;
					align-items: center;
					flex-wrap: wrap;

					.item {
						width: 126px;
						height: 126px;
						margin: 0 22px 22px 0;
						border: 1px solid #0b5979;

						.icom_f {
							width: 124px;
							height: 124px;

							img {
								width: 124px;
								height: 124px;
							}
						}
					}

					.item:nth-child(8n) {
						margin: 0 0px 22px 0;
					}
				}
			}

			/* 班级信息 GO */
			.pro-squadInfo {
				margin-top: 86px;
				margin-left: 30px;

				.row {
					margin-right: 0px;
					margin-left: 0px;
				}

				.info_tit {
					margin-top: 0px;
					margin-bottom: 0px;

					.tit_left {
						span:first-child {
							font-size: 30px;
							color: #000;
							font-weight: bold;
						}
					}
				}

				.squadInfo_content {
					display: flex;
					flex-wrap: wrap;
					margin-top: 32px;

					.item {
						margin-right: 58px;
						margin-bottom: 58px;

						.pic {
							img {
								width: 340px;
								height: auto;
							}
						}

						.bottom {
							width: 340px;
							margin: 20px 0 0px 0;
							display: flex;
							align-items: center;
							justify-content: space-between;
							color: #1a1a1a;

							.title {
								width: 620px;
								height: 32px;
								line-height: 32px;
								font-size: 18px;
							}
						}

						.bottom:hover {
							color: #006170;
							cursor: pointer;
						}
					}

					.item:hover {
						margin: -29px 29px 29px -29px;
						padding: 29px;
						background: #f0f4f5;
					}

					.item:nth-child(3n) {
						margin-right: 0px;
					}

					.item:nth-child(3n):hover {
						margin: -29px -29px 29px -29px;
						padding: 29px;
					}
				}
			}

			/* 就业jiuye信息 GO */
			.pro-employment {
				margin-top: 26px;
				margin-left: 30px;

				.row {
					margin-right: 0px;
					margin-left: 0px;
				}

				.info_tit {
					margin-top: 0px;
					margin-bottom: 0px;

					.tit_left {
						span[data-v-37773d3a]:first-child {
							font-size: 24px;
							color: #000;
							font-weight: bold;
						}
					}
				}

				.jiuye {
					.item {
						width: 100%;
						height: 105px;
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						color: #000000;
						border-bottom: 1px solid #e6e6e6;

						.occupation {
							width: 30%;
							height: 105px;
							font-size: 24px;
							display: flex;
							align-items: center;
							font-weight: 500;
						}

						.firm {
							width: 30%;
							height: 105px;
							font-size: 18px;
							display: flex;
							align-items: center;
						}

						.data {
							width: 40%;
							height: 105px;
							font-size: 20px;
							color: #8d8d8d;
							display: flex;
							align-items: center;
							justify-content: flex-end;
						}
					}

					// .item:hover{background: #f0f4f5;}
				}
			}
		}

		.liebiao_list:hover .liebiao_info::after {
			background: #ffffff;
		}

		.liebiao_info:last-child::after {
			display: none;
		}

		.info_left {
			margin-right: 30px;
			overflow: hidden;
			position: relative;

			img {
				width: 100%;

				&:hover {
					transform: scale(1.2)
				}
			}

			.border-hover {
				border: 1px solid #ffffff;
				position: absolute;
				top: 5px;
				left: 5px;
				transform: scale(1.3);
				-webkit-transform: scale(1.3);
				-moz-transform: scale(1.3);
				-o-transform: scale(1.3);
				-ms-transform: scale(1.3);
			}
		}

		.info_left:hover .border-hover {
			transform: scale(1);
			-webkit-transform: scale(1);
			-moz-transform: scale(1);
			-o-transform: scale(1);
			-ms-transform: scale(1);
		}

		.info_right {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.right_down {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			font-size: 12px;
			color: #999;
		}

		.jieshao {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			font-size: 14px;
			color: #333;
		}

		.right_down_div {
			display: flex;
			align-items: center;
		}

		.right_tit {
			font-size: 24px;
			color: #000;
		}

		.right_tit:hover {
			color: #006170;
		}
	}

	.m-dqgyList .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-dqgyList .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-dqgyList .fenye {
		margin-top: 50px;
		text-align: center;
	}

	.m-dqgyList .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}

	.count_info .subject_count_right {
		float: right;
	}

	.subject_count_right .commo_div {
		width: 230px;
		background: #006170;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 15px 20px;
		color: #fff;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.subject_count_right .commo_div img {
		width: 15px;
		height: 15px;
	}

	.commo_list span {
		display: block;
		width: 100%;
		padding: 15px 20px;
		text-align: center;
		background: #f0f4f5;
		border-bottom: 1px solid #dddee4;
		color: #000;
		font-weight: bold;
		cursor: pointer;
	}

	.commo_list .active_style {
		border: 1px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #307f8b;
		background: #fff;
		margin-bottom: 10px;
	}

	.yszx_list .list_info {
		margin-bottom: 30px;

		img {
			width: 100%;
			margin-bottom: 10px;
		}

		span {
			color: #000;
		}
	}

	.pointer {
		cursor: pointer;
	}

	.tit_right:hover {
		opacity: .8;
		cursor: pointer;
	}

	.pro-news1 {
		position: relative;
		left: 30px;
		width: 1200px;

		.liebiao_list {
			margin: 20px 0 0 0;

			.liebiao_info {
				width: calc(100% + 60px);
				display: flex;
				flex-direction: row;
				justify-content: flex-start;
				padding: 30px 30px 30px 30px;
				cursor: pointer;
				position: relative;
				left: 0px;

				&:hover {
					background: #f0f4f5;
				}

				&::after {
					width: calc(100% - 60px);
					height: 1px;
					content: '';
					background: #f0f4f5;
					display: block;
					position: absolute;
					bottom: 0px;
				}

				.info_left {
					width: 320px;
					height: 180px;
					margin-right: 0px;

					img {
						width: 320px;
						height: 180px;

					}
				}

				.info_right {
					width: 805px;
					height: 180px;
					margin-left: 40px;
					margin-right: -30px;
				}
			}
		}
	}

	.spe {
		width: calc(100% + 20px) !important;
	}

	.short {
		width: calc(100% - 30px) !important;
	}

	.spe .info_right {
		padding-right: 30px;
	}

	.pro-news.last {
		margin-top: 42px;
	}

	@media screen and (max-width: 1400px) {
		.m-dqgyList .list_info {
			width: 100%;
		}
	}
</style>
